const getGroupAspectRatio = (items) => {
  if (!items || items.length === 0) return null;

  return items[0].aspectRatio;
};

export default getGroupAspectRatio;
